<div [class]="(lateralMenu || carrousel) ? 'apply-one-style' : ''">
  <div [class]="(lateralMenu || carrousel) ? 'site-width' : ''">
    <div [class]="(lateralMenu || carrousel) ? 'container-fluid' : ''">
      <div [class]="(lateralMenu || carrousel) ? 'row' : ''">
        @if ((isXlScreen || carrousel) && (lateralMenu || carrousel)) {
          <div class="col-xl-3 col-12 menu-sticky">
            <ecm-carrousel [isXlScreen]="isXlScreen"></ecm-carrousel>
          </div>
        }
        <div [class]="(lateralMenu || carrousel) ? 'col-12 offset-xl-1 col-xl-7' : ''">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
